const BaseComponent = require('common/newsCarousel');

class switchImg extends BaseComponent {
}

module.exports = switchImg;
